/**
 * Keep in sync with `projects/app/public/registerServiceWorker.js`
 * (`isServiceWorkerRegistrationSkippedForBot`, `isServiceWorkerRegistrationSkippedForPath`).
 */
export const SERVICE_WORKER_REGISTRATION_SKIP_USER_AGENT =
  /Google-Read-Aloud|Googlebot\/|Google-InspectionTool|GoogleProducer/i;

/** Apps without browser notifications — keep in sync with registerServiceWorker.js */
export const SERVICE_WORKER_REGISTRATION_SKIP_PATH_PREFIXES = [
  "/providersearch",
  "/acp",
] as const;

export function shouldSkipServiceWorkerRegistrationForUserAgent(): boolean {
  if (typeof navigator === "undefined") {
    return false;
  }
  return SERVICE_WORKER_REGISTRATION_SKIP_USER_AGENT.test(navigator.userAgent);
}

export function shouldSkipServiceWorkerRegistrationForPath(
  pathname: string = typeof window !== "undefined"
    ? window.location.pathname
    : "",
): boolean {
  return SERVICE_WORKER_REGISTRATION_SKIP_PATH_PREFIXES.some((prefix) =>
    pathname.startsWith(prefix),
  );
}

export function shouldSkipServiceWorkerRegistration(): boolean {
  return (
    shouldSkipServiceWorkerRegistrationForUserAgent() ||
    shouldSkipServiceWorkerRegistrationForPath()
  );
}
